import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import QuizManager from "./QuizManager";
import UserList from "./UserList";
import WithdrawalSettings from "./WithdrawalSettings";
import WithdrawRequests from "./WithdrawRequests";
import BannerManager from "./BannerManager";
import "./Admin.css";
import RechargeManager from "./RechargeManager";
import RechargeRequests from "./RechargeRequests";


export default function Admin() {
  const navigate = useNavigate();
  const [view, setView] = useState("quizzes");

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/login");
  };

  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard</h1>
      <button className="logout-button" onClick={handleLogout}>Logout</button>

      <div className="button-group">
        <button onClick={() => setView("quizzes")}>Quiz Manager</button>
        <button onClick={() => setView("users")}>View Users</button>
        <button onClick={() => setView("withdraw")}>Withdrawal Settings</button>
        <button onClick={() => setView("withdrawReq")}>Withdraw Requests</button>
        <button onClick={() => setView("banners")}>Manage Banners</button>
        <button onClick={() => setView("recharge")}>Recharge Options</button>
        <button onClick={() => setView("rechReq")}>Recharge Requests</button>

      </div>

      {view === "quizzes" && <QuizManager />}
      {view === "users" && <UserList />}
      {view === "withdraw" && <WithdrawalSettings />}
      {view === "withdrawReq" && <WithdrawRequests />}
      {view === "banners" && <BannerManager />}
      {view === "recharge" && <RechargeManager />}
      {view === "rechReq" && <RechargeRequests />}
    </div>
  );
}
